import React, { Component } from 'react';
import { Table, Modal, Input, message, Button, Radio, Switch, Checkbox, InputNumber, } from 'antd';
import { DeleteOutlined, EyeOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './index.module.css';
import { getFeedback, putFeedback } from '../../services/feed';
import { getDepartment_Data } from '../../config/storage';
import Link from '../../resource/png/link.png';
import { getVideoPlay, getVideoSub, } from '../../services/newOder';
import moment from 'moment';

const initFeed = {
  id: 0,
  type: '',
  price_shop: 0,
  price_worker: 0,
  state: '',
  content: '',
  isAsync: false,
};
class FeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      feedInfo: {
        pic: [],
        vod: [],
        follows: [],
        checkers: [],
      },
      orderInfo: {
        price_app: 0,
        add_app: 0,
      },
      backAll: {
        ...initFeed,
        type: '总体',
        state: '待处理',
      },
      backSin: {
        ...initFeed,
        type: '个人',
        state: '待处理',
      },
    };
    this.baseUrl = getDepartment_Data().service;
    this.selfId = getDepartment_Data().id;
    this.columns1 = [
      {
        title: '房间',
        align: 'center',
        dataIndex: 'room',
        width: 100,
        className: 'padding0',
      },
      {
        title: '长度(米)',
        align: 'center',
        dataIndex: 'width',
        width: 100,
        className: 'padding0',
      },
      {
        title: '品类',
        align: 'center',
        dataIndex: 'prop1',
        width: 100,
        className: 'padding0',
      },
      {
        title: '层数',
        align: 'center',
        dataIndex: 'room',
        width: 100,
        className: 'padding0',
        render: (text, record, index) => {
          return (
            <div>{record.prop4 !== '' && JSON.parse(record.prop4).name}</div>
          )
        }
      },
      {
        title: '个数',
        align: 'center',
        dataIndex: 'prop2',
        width: 100,
        className: 'padding0',
      },
      {
        title: '价格',
        align: 'center',
        dataIndex: 'prop10',
        width: 100,
        className: 'padding0',
      },
    ];
    this.colums2 = [
      {
        title: '客服',
        align: 'center',
        dataIndex: 'name',
        width: 100,
        className: 'padding0',
      },
      {
        title: '时间',
        align: 'center',
        dataIndex: 'time',
        width: 80,
        className: 'padding0',
        render: (text, record, index) => {
          return (
            <div>{moment(record.time).format('YYYY-MM-DD HH:mm:ss')}</div>
          )
        }
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'content',
        width: 220,
        className: 'padding0',
      },
    ];
  }
  render() {
    const { visible, feedInfo, orderInfo, backAll, backSin } = this.state;

    return (
      <Modal
        title='反馈详情'
        visible={visible}
        width={1360}
        onCancel={this.onCancel}
        destroyOnClose={true}
        footer={
          <div className='row-r w100'>
            <Button onClick={this.onCancel}>关闭</Button>
          </div>
        }
      >
        <div className='col-t vertical-lt'>
          <div className='row-l vertical-lt'>
            <div className='col-t vertical-lt w640 padding-r10'>
              <div className='row-l margin-b10'>
                <div className='fz20'>问题反馈：</div>
                <div>{feedInfo.feed_str}</div>
              </div>
              <div className='row-l'>
                <div className='w80'>问题类型：</div>
                <div>{feedInfo.detail_str}</div>
              </div>
              {
                feedInfo.cash === '是' &&
                <div className='row-l'>
                  <div className='w80'>费用：</div>
                  <div>商户：{feedInfo.price_shop}</div>
                  <div className='margin-l20'>师傅：{feedInfo.price_worker}</div>
                </div>
              }

              <div className='row-l vertical-lt w600'>
                <div className='w80'>问题描述：</div>
                <div className='w500'>
                  {feedInfo.remark}
                  <img src={Link} onClick={this.toCopy.bind(this, feedInfo.remark)} className='cursor-pointer' />
                </div>
              </div>
              {
                feedInfo.pic.length > 0 &&
                <div className='row-l'>
                  <div className='w80'>问题图片：</div>
                  <div className='w500 row-w'>
                    {
                      feedInfo.pic.map((item, index) => {
                        return (
                          <div key={index} className={`${styles['content']}`}>
                            <img
                              alt='暂无图片'
                              className={`${styles['pic2']}`}
                              src={`${this.baseUrl}/upload/${item}`}
                            />
                            <div className={`row ${styles['content-div']}`}>
                              <EyeOutlined
                                className={`${styles['pic-icon-E']}`}
                                onClick={this.preview.bind(this, `${this.baseUrl}/upload/${item}`)}
                                theme='outlined'
                                title='预览'
                              />
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              }
              {
                feedInfo.vod.length > 0 &&
                <div className='row-l vertical-lt'>
                  <div className='w80'>问题视频：</div>
                  <div className='w500 row-w'>
                    {
                      feedInfo.vod.map((item, index) => {
                        return (
                          <div className={`${styles['content-video']} margin-r10`} key={index}>
                            <video controls='controls' className={styles['content-image']} src={item} />
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              }
            </div>
            <div className='col-t vertical-lt w640 padding-l10'>
              <div className='row-l margin-t10'>
                <div>申请人：{feedInfo.sub_name}</div>
                <div className='margin-l20'>申请时间：{feedInfo.submit_time}</div>
              </div>
              <div className='row-l margin-t10'>
                <div>关联订单：</div>
                <div>{feedInfo.order}
                </div>
                <div className='bord2 w70 tc border5 color3 margin-l20'>{orderInfo.service}</div>
              </div>
              <div className='row-l vertical-lt margin-t10'>
                <div>客户信息：</div>
                <div className='col-t vertical-lt'>
                  <div>
                    {orderInfo.name} - {orderInfo.phone}
                    <img src={Link} onClick={this.toCopy2.bind(this, orderInfo)} className='cursor-pointer' />
                  </div>
                  <div>{orderInfo.province}{orderInfo.city}{orderInfo.district}{orderInfo.address}</div>
                </div>
              </div>
              <div className='row-l margin-t10'>
                <div>订单费用：</div>
                <div>{orderInfo.price_app + orderInfo.add_app}</div>
              </div>
              {
                orderInfo.service === '安装' && orderInfo.category === '窗帘' &&
                <div className='w100'>
                  <Table
                    columns={this.columns1}
                    dataSource={orderInfo.serviceDatas}
                    size={'small'}
                    className='w100'
                    rowKey={record => record.id}
                    bordered
                    pagination={false}
                  />
                </div>
              }
            </div>
          </div>

        </div>
      </Modal>
    );
  }
  getInfo = async (id) => {
    let res = await getFeedback(id);
    if (res.status === 200) {
      let feedInfo = res.data.f;
      feedInfo.pic = JSON.parse(feedInfo.pic);
      feedInfo.vod = JSON.parse(feedInfo.vod);
      let that = this;
      feedInfo.vod.map((item, index) => {
        (async () => {
          let local = index;
          if(item.includes('vod.lijuyun')){
            that.setState({
              feedInfo
            });
          }else{
            let rsp = await getVideoPlay(item);
            if (rsp.status === 200) {
              feedInfo.vod[local] = rsp.data.playURL;
              that.setState({
                feedInfo
              });
            }
          }
        })()
      });
      this.setState({
        feedInfo,
        orderInfo: res.data.o,
      });
    }
  }

  onShow = (e) => {
    this.setState({
      visible: true,
    })
    this.getInfo(e.id);
  }
  onCancel = () => {
    this.setState({
      visible: false,
      orderInfo: {
        price_app: 0,
        add_app: 0,
      },
    })
  }
  preview = (url) => {
    let features = 'height=500, width=800, top=100, left=100, toolbar=no, menubar=no,scrollbars=no,resizable=no, location=no, status=no';
    window.open(url, 'newW', features);
  }
  toCopy = (e) => {
    var aux = document.createElement("textarea");
    aux.value = e;
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    message.success('复制成功');
  }
  //复制
  toCopy2 = (data) => {
    var aux = document.createElement("textarea");
    aux.value = `${'姓名:' + data.name + '\n' + '手机号:' + data.phone + '\n' + '地址:' + data.province + data.city + data.district + data.address
      }`;
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    message.success('复制成功');
  }
}
export default FeedbackModal;